import { useRef, useState } from 'react';
import CarouselNextArrowIcon from '@/components/Common/Icons/CarouselNextArrowIcon';
import CarouselBackArrowIcon from '@/components/Common/Icons/CarouselBackArrowIcon';
import Slider from 'react-slick';
import Spinner from '@/components/Common/Spinner';
import FileLandscape from '@/components/Common/Icons/FileLandscapeIcon';
import './index.less';
import Image from 'next/image';

interface ProductImagesSimpleSlideProps {
  images: string[];
}

const ProductImagesSimpleSlide = ({ images }: ProductImagesSimpleSlideProps) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const sliderRef = useRef(null);

  const sliderSettings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: (
      <div>
        <CarouselNextArrowIcon fill="#fff" />
      </div>
    ),
    prevArrow: (
      <div>
        <CarouselBackArrowIcon fill="#fff" />
      </div>
    ),
    afterChange: (index: number) => {
      setCurrentImageIndex(index);
    },
  };

  return (
    <div className="product-images-simple-slide">
      <div className="slider-box">
        <Slider className="slider" ref={sliderRef} {...sliderSettings}>
          {images.map((img, i) => {
            if (!img) {
              return <Spinner key={`img-loading-${i}`} />;
            } else {
              return (
                <>
                  <Image
                    className="product-img"
                    key={`img-${i}`}
                    src={img}
                    alt={'Product image No.' + i}
                    width={382}
                    height={320}
                    sizes="(max-width: 414px) calc(100vw - 32px), 382px"
                    {...(i === 0 ? { priority: true } : { loading: 'lazy' })}
                  />
                </>
              );
            }
          })}
        </Slider>
        <div className="mask">
          <div className="img-info">
            <FileLandscape />
            <p className="img-num">
              {currentImageIndex + 1} / {images.length}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductImagesSimpleSlide;
